const MEDIA_ATTACHMENT_TYPES = new Set(['IMAGE', 'VIDEO', 'STICKER', 'GIF', 'MEDIA']);
const MEDIA_CONTENT_TYPE_PREFIXES = ['IMAGE/', 'VIDEO/', 'AUDIO/'];

export function resolveAttachmentIcon(type: string | null | undefined): string | null {
  const normalizedType = String(type ?? '').trim().toUpperCase();
  if (!normalizedType) return null;

  const isMedia =
    MEDIA_ATTACHMENT_TYPES.has(normalizedType) ||
    MEDIA_CONTENT_TYPE_PREFIXES.some(prefix => normalizedType.startsWith(prefix));

  return isMedia ? 'image' : 'icon_document';
}
